import * as ewe from "@eyeo/webext-ad-filtering-solution";
import browser from "webextension-polyfill";
function onBeforeSendHeadersListener(details) {
    if (!(details === null || details === void 0 ? void 0 : details.requestHeaders)) {
        return {};
    }
    const headers = [...details.requestHeaders];
    headers.push({
        name: "X-Acceptable-Ads",
        value: "1",
    });
    return { requestHeaders: headers };
}
function addRequestHeader() {
    browser.webRequest.onBeforeSendHeaders.addListener(onBeforeSendHeadersListener, { urls: ["*://btloader.com/tag?*"], types: ["script"] }, ["blocking", "requestHeaders", "extraHeaders"]);
}
function removeRequestHeader() {
    browser.webRequest.onBeforeSendHeaders.removeListener(onBeforeSendHeadersListener);
}
async function filterChangeListener() {
    if (browser.runtime.getManifest().manifest_version === 3) {
        return;
    }
    if (await ewe.subscriptions.has(ewe.subscriptions.ACCEPTABLE_ADS_URL)) {
        addRequestHeader();
    }
    else {
        removeRequestHeader();
    }
}
export async function start() {
    await filterChangeListener();
    ewe.subscriptions.onAdded.addListener(filterChangeListener);
    ewe.subscriptions.onRemoved.addListener(filterChangeListener);
}
